import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { DialogRef } from '@angular/cdk/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
	LabBrokerUnavailableDialogComponent,
	DentiraUnavailableResult,
	LabBrokerUnavailableDialogData
} from './lab-broker-unavailable-dialog.component';

@Injectable({ providedIn: 'root' })
export class LabBrokerUnavailableDialogService {
	private activeRef: DialogRef<DentiraUnavailableResult> | null = null;

	constructor(private readonly modalService: TlkModalWindowService) {}

	open(integratorName: string): Observable<DentiraUnavailableResult> {
		const dialogRef = this.modalService.open<
			DentiraUnavailableResult,
			LabBrokerUnavailableDialogData,
			LabBrokerUnavailableDialogComponent
		>(LabBrokerUnavailableDialogComponent, { data: { name: integratorName } });

		this.activeRef = dialogRef;

		return dialogRef.closed.pipe(
			map(result => {
				this.activeRef = null;

				return result ?? null;
			})
		);
	}

	closeIfOpen(): void {
		this.activeRef?.close(null);
		this.activeRef = null;
	}
}
